import CheckCircle from '@mui/icons-material/CheckCircle';
import TuneOutlined from '@mui/icons-material/TuneOutlined';
import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import { IconBadge } from './IconBadge.js';
import { Pill, PRIMARY_PILL_SX } from './Pill.js';
import { SelectableCard } from './SelectableCard.js';
import { iconFor } from './workflowIcons.js';
import type { PresetCardsField as PresetCardsFieldData } from './workflows.types.js';

const CARD_MIN_WIDTH = 240;
const CARD_COLUMNS = `repeat(auto-fit, minmax(${CARD_MIN_WIDTH}px, 1fr))`;

interface PresetCardsFieldProps {
  field: PresetCardsFieldData;
  value: string;
  onChange: (value: string) => void;
}

export function PresetCardsField({ field, value, onChange }: PresetCardsFieldProps): ReactNode {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: CARD_COLUMNS, gap: 3 }}>
      {field.options.map((option) => {
        const selected = option.id === value;

        return (
          <SelectableCard
            key={option.id}
            testId={`preset-${option.id}`}
            ariaPressed={selected}
            onClick={() => onChange(option.id)}
            {...(selected ? { accent: 'primary.main' } : {})}
            icon={<IconBadge icon={iconFor(option.icon, TuneOutlined)} />}
            title={option.label}
            {...(option.tag === null
              ? {}
              : { badge: <Pill sx={PRIMARY_PILL_SX}>{option.tag}</Pill> })}
            {...(selected
              ? { trailing: <CheckCircle sx={{ fontSize: 16, color: 'common.black' }} /> }
              : {})}
            tooltip={option.tooltip}
            subtitle={option.description}
            chips={option.chips.map((chip) => `${chip.label} ${chip.text}`)}
          />
        );
      })}
    </Box>
  );
}
